import { Box, Grid, styled } from '@mui/material'

export const FieldWrapper = styled(Grid)(({ theme }) => ({
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))

export const LabeledDateFieldGroup = styled(Box)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(1),
}))

export const DateFieldInputRow = styled(Grid)(({ theme }) => ({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}))

export const DateFieldClearButtonCell = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  flexShrink: 0,
  height: 40,
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    height: 40,
  },
}))
